<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w4tVuJ/cover.jpeg?1685327317917" alt="This image is the cover for the book Hegemon of Chaos, Volume 4"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hegemon of Chaos, Volume 4
      </h1>
      <p class="bookDescription body article font2">
        <p>For longevity, countless cultivators would use all sorts of methods to either hone themselves, ascend one level at a time, or treat all living things as ruminants, regardless of the method. It was a deceitful, deceitful, dark, and magnificent scene of hundreds of millions of cultivators fighting in the air and on the ground. It was both a place of longevity and a place of protection for all living things …"God's camp 136877794, welcome to the camp!"Is Long...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ai ChiPingGuoDeHouZi, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20eea49c